import React, { useEffect, useState } from 'react';
import client from '../api/client';
import toast from 'react-hot-toast';

function StatCard({ title, value, subtitle, icon }) {
  return (
    <div className="bg-slate-800 rounded-xl p-5 border border-slate-700">
      <div className="flex items-center gap-3 mb-2">
        <span className="text-2xl">{icon}</span>
        <p className="text-slate-400 text-xs font-medium uppercase tracking-wider">{title}</p>
      </div>
      <p className="text-3xl font-bold text-white">{value ?? '—'}</p>
      {subtitle && <p className="text-xs text-slate-500 mt-1">{subtitle}</p>}
    </div>
  );
}

export default function Notifications() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchStats(); }, []);

  const fetchStats = async () => {
    try {
      const res = await client.get('/api/v1/admin/notifications/stats');
      setStats(res.data);
    } catch (e) {
      toast.error('Bildirim verileri yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  const byType = stats?.by_type || {};

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-white">🔔 Bildirim Yönetimi</h2>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="Toplam Cihaz"
          value={stats?.total_devices || 0}
          icon="📱"
        />
        <StatCard
          title="Aktif Cihaz"
          value={stats?.active_devices || 0}
          subtitle="Push almaya uygun"
          icon="✅"
        />
        <StatCard
          title="Pasif Cihaz"
          value={stats?.inactive_devices || 0}
          icon="🚫"
        />
        <StatCard
          title="Aktiflik Oranı"
          value={stats?.total_devices ? `${Math.round((stats.active_devices / stats.total_devices) * 100)}%` : '—'}
          icon="📊"
        />
      </div>

      {/* Platform Distribution */}
      <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
        <h3 className="text-lg font-bold text-white mb-4">Platform Dağılımı (Aktif Cihazlar)</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {Object.entries(byType).length === 0 ? (
            <p className="text-slate-500 text-sm">Henüz kayıtlı cihaz yok</p>
          ) : (
            Object.entries(byType).map(([type, count]) => {
              const total = Object.values(byType).reduce((a, b) => a + b, 0);
              const pct = total ? Math.round((count / total) * 100) : 0;
              const icons = { android: '🤖', ios: '🍎' };
              const barColors = { android: 'bg-emerald-500', ios: 'bg-blue-500' };
              return (
                <div key={type} className="bg-slate-700/50 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xl">{icons[type] || '📱'}</span>
                    <span className="text-white font-bold capitalize">{type}</span>
                  </div>
                  <p className="text-3xl font-bold text-white">{count}</p>
                  <div className="w-full bg-slate-600 rounded-full h-2 mt-2">
                    <div className={`${barColors[type] || 'bg-indigo-500'} h-2 rounded-full`} style={{ width: `${pct}%` }} />
                  </div>
                  <p className="text-xs text-slate-500 mt-1">{pct}% toplam</p>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* Info */}
      <div className="bg-indigo-500/10 border border-indigo-500/30 rounded-xl p-5">
        <p className="text-sm text-indigo-300">
          💡 <strong>İpucu:</strong> Test bildirimi göndermek için <strong>📅 Content</strong> sayfasındaki
          "🔔 Test Bildirimi Gönder" kartını kullanabilirsiniz.
        </p>
      </div>
    </div>
  );
}
